import { Flex } from "@chakra-ui/react";
import { FaRegTimesCircle } from "react-icons/fa";
import colors from "core/resources/theme/colors";

interface DateRangePickerClearButtonProps {
  onClear: () => any;
  right: string | number;
}

function DateRangePickerClearButton({
  onClear,
  right,
}: DateRangePickerClearButtonProps) {
  return (
    <Flex
      position="absolute"
      top="10.5px"
      right={right}
      w="30px"
      h="30px"
      cursor="pointer"
      alignItems="center"
      justifyContent="center"
      _hover={{
        opacity: 0.7,
      }}
      rounded="full"
      onClick={(ev) => {
        ev.stopPropagation();
        onClear();
      }}
    >
      <FaRegTimesCircle color={colors.darkGray} />
    </Flex>
  );
}

export default DateRangePickerClearButton;
